import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';

import TimelineHeader from './common/TimelineHeader';

import AbstractTimelineEvent from 'components/layout/embeddedTimeline/AbstractTimelineEvent';

class TimelineMailOrderCancelled extends AbstractTimelineEvent {
  render() {
    const { intl, appIntl } = this.props;
    const messages = intl.messages;

    return (
      <div>
        <TimelineHeader
          creatorId={this.getDynParam('creatorId')}
          creatorAvatar={this.getDynParam('creatorAvatar')}
          creatorName={this.getDynParam('creatorName')}
          title={messages.order_cancelled}
        />

        <div class="card-block">
          <Row>
            <Col xs={12}>
              <p>
                {messages.order} #{this.getParam('orderId')}
              </p>
            </Col>
          </Row>

          <Row>
            <Col xs={4}>{messages.salesDoc.total_due}</Col>
            <Col xs={8}>
              <FormattedNumber
                value={this.getDynParam('sumGross')}
                style="currency"
                currency={this.getDynParam('currency')}
              />
            </Col>
          </Row>

          <div class="p-b-5" />

          <Row>
            <Col xs={12}>
              <Link to={appIntl.urlPrefix + 'account/orders/' + this.getParam('orderId')} class="btn">
                <i class="fa fa-angle-double-right" /> {messages.view}
              </Link>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
TimelineMailOrderCancelled.propTypes = {
  event: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(TimelineMailOrderCancelled));
